module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n6r8r7r-8af0a10fd0201656eed21be69893fedb.svg";